import i18n from "@/core/plugins/vue-i18n";

// getter types
export const DIALOG_DATA = "dialogData";

// action types
export const OPEN_DIALOG = "openDialog";
export const DO_OK = "doOk";
export const DO_CANCEL = "doCancel";

// mutation types
const SET_DATA = "setData";
const RESET_DATA = "resetData";
const SET_OPEN_DIALOG = "setOpenDialog";

export const DIALOG_TYPE_ENUM = Object.freeze({
  success: "Success",
  info: "Info",
  warning: "Warning",
  error: "Error"
});

const state = {
  dialog: {
    open: false,
    title: i18n.t("General.Dialog.Titles.Warning"),
    text: null,
    type: DIALOG_TYPE_ENUM.warning,
    buttons: {
      ok: {
        display: true,
        title: i18n.t("General.Ok"),
        callback: null
      },
      cancel: {
        display: false,
        title: i18n.t("General.Cancel")
      }
    }
  }
};

const getters = {
  [DIALOG_DATA](state) {
    return state.dialog;
  }
};

const actions = {
  [OPEN_DIALOG](context, payload) {
    context.commit(SET_DATA, payload);
    context.commit(SET_OPEN_DIALOG, true);
  },
  [DO_OK](context) {
    context.commit(SET_OPEN_DIALOG, false);

    const callback = context.state.dialog.buttons.ok.callback;
    if (callback && typeof callback === "function") {
      callback();
    }

    context.commit(RESET_DATA);
  },
  [DO_CANCEL](context) {
    context.commit(SET_OPEN_DIALOG, false);
    context.commit(RESET_DATA);
  }
};

const mutations = {
  [SET_OPEN_DIALOG](state, isOpen) {
    state.dialog.open = isOpen;
  },
  [SET_DATA](state, data) {
    state.dialog.type = data?.type ?? DIALOG_TYPE_ENUM.warning;
    state.dialog.title =
      data?.title ?? i18n.t(`General.Dialog.Titles.${state.dialog.type}`);
    state.dialog.text = data?.text ?? null;

    state.dialog.buttons.ok.display = data?.buttons?.ok?.display ?? true;
    state.dialog.buttons.ok.title =
      data?.buttons?.ok?.title ?? i18n.t("General.Ok");
    state.dialog.buttons.ok.callback = data?.buttons?.ok?.callback ?? null;

    state.dialog.buttons.cancel.display =
      data?.buttons?.cancel?.display ?? false;
    state.dialog.buttons.cancel.title =
      data?.buttons?.cancel?.title ?? i18n.t("General.Cancel");
  },
  [RESET_DATA](state) {
    state.dialog.type = DIALOG_TYPE_ENUM.warning;
    state.dialog.title = i18n.t("General.Dialog.Titles.Warning");
    state.dialog.text = null;

    state.dialog.buttons.ok.display = true;
    state.dialog.buttons.ok.title = i18n.t("General.Ok");
    state.dialog.buttons.ok.callback = null;

    state.dialog.buttons.cancel.display = false;
    state.dialog.buttons.cancel.title = i18n.t("General.Cancel");
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
